// dialogs namespace - the generate/render/session modal bundle
// (components/modals/index.tsx) and the pack upload modal.
//
// These strings used to be hardcoded Polish inside the components, so an EN user
// hit Polish at the three worst possible moments: paying, running out of gems and
// a failed render. Keys mirror en/dialogs.ts exactly.
//
// Gem/edit unit words come from locales/plural.ts (Polish has three forms), so the
// sentences here take {gems} / {edits} already inflected.
export const dialogs = {
  close: 'Zamknij',

  // Wyjście w trakcie wgrywania (lib/useLeaveGuard.ts): pytanie zadaje zwykły
  // ConfirmDialog, więc „Zostań” dostaje fokus i Enter nigdy nie kasuje roboty.
  leaveGuard: {
    title: 'Przerwać?',
    body: 'Wgrywanie jeszcze trwa. Jeśli wyjdziesz, zacznie się od nowa.',
    stay: 'Zostań',
    leave: 'Wyjdź',
  },

  confirmGenerate: {
    title: 'Wygenerować {count} {edits}?',
    body: 'Każdy edit powstaje osobno - inne cięcia i inne klipy, ta sama muzyka i ten sam styl tekstu.',
    costLabel: 'Koszt',
    afterLabel: 'Po wygenerowaniu zostanie',
    refundNote: 'Nieudany render zwraca tokeny automatycznie.',
    cancel: 'Anuluj',
    confirm: 'Generuj',
  },

  // Sesja 30, artboard 08c: tytuł „Za mało gemów” (rozstrzygnięcie koordynatora,
  // runda 2) i JEDNO zdanie, które niesie wszystkie trzy liczby. Tabela
  // Potrzeba / Masz / Brakuje wyleciała - mówiła to samo drugi raz.
  // R5 (reguła 34 + zasada 8, artboard 08c): tytuł, TABELA Koszt / Masz, „Doładuj
  // tokeny”. Zdanie „Masz 0, potrzeba 3. Brakuje 3.” wyleciało — trzecia liczba była
  // odejmowaniem dwóch pierwszych, a zdanie mówiło to, co tabela pokazuje. Klucz
  // `body` zostaje pusty w produkcie i żyje wyłącznie dla buildu natywnego niżej.
  noGems: {
    title: 'Za mało tokenów',
    // Tylko w aplikacji mobilnej: tam nie ma akcji „Doładuj tokeny” (zasada sklepów),
    // więc bez tego zdania tabela byłaby ślepym zaułkiem.
    hintNative: 'Zmniejsz liczbę editów - tokeny dokupisz na stronie.',
    back: 'Anuluj',
    topUp: 'Doładuj tokeny',
  },

  progress: {
    title: 'Składam Twój edit…',
    body: 'Tniemy i sklejamy klipy w rytm beatu. Możesz zamknąć to okno - render leci dalej.',
    background: 'Zamknij, render leci dalej',
    close: 'Zamknij',
  },

  done: {
    title: 'Edit gotowy',
    body: 'Nowy edit jest gotowy. Pobierz go albo otwórz w Editach.',
    // gdy znamy serię i numer (ponowny render ze strony editu)
    bodySeries: 'Nowy edit {n} jest w serii „{series}”. Pobierz go albo otwórz w Editach.',
    download: 'Pobierz MP4',
    library: 'Zobacz w Editach',
    edits: 'Zobacz w Editach',
  },

  // Usunięcie editu (artboard 13b): ConfirmDialog z nazwą, rozmiarem i zdaniem o gemach.
  deleteEdit: {
    title: 'Usunąć edit „{name}”?',
    body: 'Zniknie plik MP4 ({size}).',
    confirm: 'Usuń edit',
  },

  failed: {
    title: 'Render się nie udał',
    body: 'Coś poszło nie tak przy składaniu editu. Nic nie tracisz - tokeny wróciły do Twojej puli.',
    statusLabel: 'Status',
    statusValue: 'Przerwany',
    refundLabel: 'Zwrócone tokeny',
    close: 'Zamknij',
    retry: 'Spróbuj ponownie',
  },

  sessionExpired: {
    title: 'Sesja wygasła',
    body: 'Zaloguj się ponownie, żeby wrócić do pracy. Twoje edity i tokeny są bezpieczne.',
    login: 'Zaloguj się ponownie',
  },

  // Modal wgrywania packa. Był w 100% zahardkodowanym polskim - angielski
  // użytkownik dostawał polskie okno w środku wgrywania własnych plików.
  // Nazwa przełącznika wzięta z canvasu 05 („Potnij na osobne klipy"):
  // mówi, co się STANIE, zamiast nazywać technologię.
  packUpload: {
    title: 'Wgraj klipy do paczki',
    appendTitle: 'Dodaj pliki do „{name}”',
    nameLabel: 'Nazwa paczki',
    namePlaceholder: 'np. Teledysk - zima',
    collectionLabel: 'Kolekcja',
    collectionUnassigned: 'Nieprzypisane',
    filesLabel: 'Pliki',
    dropStrong: 'Upuść pliki tutaj',
    dropRest: ' lub kliknij, żeby wybrać',
    dropFormats: '.mp4 · .mov · .webm · .mkv',
    cutTitle: 'Potnij na osobne klipy',
    removeFile: 'Usuń {name}',
    fileError: 'błąd',
    fileDone: 'gotowe',
    fileFinalizing: 'kończę…',
    fileStarting: 'start…',
    cancel: 'Anuluj',
    close: 'Zamknij',
    submit: 'Wgraj',
    submitCount: 'Wgraj ({count})',
    appendSubmit: 'Dodaj ({count})',
    createEmpty: 'Utwórz pustą paczkę',
    busy: 'Wgrywam…',
    appendBusy: 'Dodaję…',
    createBusy: 'Tworzę…',
    retryCollection: 'Spróbuj przypisać ponownie',
    finish: 'Zakończ',
    collectionError: 'Paczka „{name}” została utworzona. Nie udało się potwierdzić przypisania do kolekcji. Ponów przypisanie - pliki nie zostaną wgrane drugi raz.',
    error: 'Nie udało się zakończyć operacji. Spróbuj ponownie.',
    packBusy: 'Ta paczka jest teraz przetwarzana. Poczekaj na zakończenie i spróbuj ponownie.',
    storageFull: 'Brakuje miejsca w bibliotece. Zwolnij miejsce przed dodaniem plików.',
    notEnoughGems: 'Brakuje tokenów na pocięcie tych plików. Zmniejsz liczbę plików lub wyłącz cięcie.',
    confirmUpload: 'Dokończ wgrywanie',
    pendingFinalize: 'Pliki zostały wysłane. Ponów potwierdzenie w tym oknie - nie wyślemy ich drugi raz.',
    partialFailure: 'Część plików została zapisana w paczce. Nie udało się dodać: {files}. Możesz dodać je ponownie później.',
    storageUnavailable: 'Przeglądarka nie pozwala zapisać postępu wgrywania. Włącz pamięć tej strony i spróbuj ponownie.',
    terminalFailure: 'Tego wgrywania nie można już dokończyć. Sprawdź bibliotekę przed ponownym dodaniem plików.',
    discardPending: 'Zamknij i sprawdź bibliotekę',
  },

  // Sesja 30, artboard 08b. Tytuł odmienia się przez liczbę editu, bo okno otwiera się
  // i ze strony jednego editu, i z karty serii, która ponawia wszystkie nieudane naraz.
  // Nazwa rzeczy zeszła z okna: otwiera je ekran, który tę rzecz właśnie pokazuje.
  reRender: {
    title_one: 'Ponowić {n} edit?',
    title_few: 'Ponowić {n} edity?',
    title_many: 'Ponowić {n} editów?',
    // JEDNO zdanie i to samo dla każdego wejścia: edit gotowy, edit nieudany, karta serii
    // (rozstrzygnięcie 9 MAPY sesji 31). Wcześniejsze „Nieudany render zwracamy w całości.”
    // było obietnicą zwrotu w oknie, które najczęściej otwiera się z editu GOTOWEGO: nic nie
    // padło, więc nic nie wróci. Fakt zwrotu zostaje na ekranie, przy rzeczy, która go dostała,
    // i tylko z ledgera (`refund_confirmed`).
    // R5 (zasada 8): „Ta sama muzyka i styl.” wyleciało — okno ma prawo do JEDNEGO
    // zdania, a drugie mówiło o rzeczach, których ponowienie i tak nie zmienia.
    body: 'Nowy render losuje klipy od nowa.',
    costLabel: 'Koszt',
    haveLabel: 'Masz',
    leftLabel: 'Zostanie',
    cancel: 'Anuluj',
    // SAM CZASOWNIK. Cenę dokleja `payLabel` („Ponów · 6 gemów”), żeby etykieta na
    // przycisku była słowo w słowo tą samą, która stała na linku w liście.
    // Forma z nawiasem („Ponów (6 gemów)”) znika z produktu (koordynator, runda 2).
    confirm: 'Ponów',
  },
} as const
